// extracted by mini-css-extract-plugin
export default {"startBreakButton":"StartBreakButton_startBreakButton__U0bjN","startBreakLabel":"StartBreakButton_startBreakLabel__nwRho"};